:host {
    position: fixed;
    top: var(--layout-body-top);
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 12px 0;
    z-index: 5000000;
    z-index: var(--zindex-toast, 5000000);
}
